import { render, staticRenderFns } from "./loginPassword.vue?vue&type=template&id=149e1332&scoped=true&"
import script from "./loginPassword.vue?vue&type=script&lang=ts&"
export * from "./loginPassword.vue?vue&type=script&lang=ts&"
import style0 from "./loginPassword.vue?vue&type=style&index=0&id=149e1332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149e1332",
  null
  
)

export default component.exports